export default __webpack_public_path__ + "static/media/Automated Delivery and Automated Consolidation.7cf557b4.pdf";